import styled from "styled-components";
import CardHeader from '@material-ui/core/CardHeader';

export const CardHeaderWrapper = styled(CardHeader)`
  .MuiCardHeader-title {
    font-weight: 900;
  }
`;